import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)
/**
 * 对user模块使用localStorage进行本地缓存
 */
export default new Vuex.Store({
  plugins: [createPersistedState({
    reducer (val) {
      return {
        user: val.user
      }
    }
  })],
  modules: {
    user
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js